export default __webpack_public_path__ + "static/media/line3_1.ac4cce0b.svg";